var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wechat"}},[_c('ul',{staticClass:"wechat-list"},_vm._l((_vm.$store.state.msgList.baseMsg),function(baseMsgObj){return _c('msg-item',{key:baseMsgObj.mid,staticClass:"list-row line-bottom",attrs:{"item":baseMsgObj}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }